import { captureStack1fzi4aczwc4hg as captureStack } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  commonAsUtf8ToByteArray20rkxdpc9aw5b as commonAsUtf8ToByteArray,
  commonToUtf8Stringyih6e1qg1yoo as commonToUtf8String,
} from './internal/-Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(message) {
        return new.target.b3w(message);
      }
      static b3w(message) {
        var $this = this.m3x(message);
        captureStack($this, $this.a3w_1);
        return $this;
      }
      static g3w() {
        return this.b3w(null);
      }
    }
    initMetadataForClass($, 'EOFException', $.g3w);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(message, cause) {
        return new.target.n3x(message, cause);
      }
      static n3x(message, cause) {
        var $this = this.yd(message, cause);
        captureStack($this, $this.l3x_1);
        return $this;
      }
      static m3x(message) {
        return this.n3x(message, null);
      }
      static o3x() {
        return this.n3x(null, null);
      }
    }
    initMetadataForClass($, 'IOException', $.o3x);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function asUtf8ToByteArray(_this__u8e3s4) {
  return commonAsUtf8ToByteArray(_this__u8e3s4);
}
var ArrayIndexOutOfBoundsExceptionClass;
function ArrayIndexOutOfBoundsException() {
  if (ArrayIndexOutOfBoundsExceptionClass === VOID) {
    class $ extends IndexOutOfBoundsException() {
      constructor(message) {
        return new.target.x3t(message);
      }
      static x3t(message) {
        var $this = this.i3(message);
        captureStack($this, $this.w3t_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ArrayIndexOutOfBoundsException');
    ArrayIndexOutOfBoundsExceptionClass = $;
  }
  return ArrayIndexOutOfBoundsExceptionClass;
}
function toUtf8String(_this__u8e3s4) {
  return commonToUtf8String(_this__u8e3s4);
}
//region block: exports
export {
  ArrayIndexOutOfBoundsException as ArrayIndexOutOfBoundsException3rm3ooo7dx3e8,
  EOFException as EOFException34hypof9gkxss,
  IOException as IOException3fje1ukjwthwb,
  asUtf8ToByteArray as asUtf8ToByteArray29u89fcaeh9ki,
  toUtf8String as toUtf8Stringtpd5urkuirog,
};
//endregion

//# sourceMappingURL=NonJvmPlatform.mjs.map
